import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SidebarNav from "@/components/feature/SidebarNav";

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <div className="mx-auto flex w-full max-w-portal flex-1 gap-8 px-4 pt-6 md:px-6 md:pt-8">
        <SidebarNav />
        <main className="min-w-0 flex-1 pb-4">{children}</main>
      </div>
      <SiteFooter />
    </div>
  );
}